import dayjs from "dayjs";
import { SelectedPets } from "../pages/book-appointments/multistep-form/pet-details/types";
import relativeTime from "dayjs/plugin/relativeTime";

export const GEO_API_URL = "https://api.geoapify.com/v1/geocode/autocomplete";
export const API_KEY = "0a47d30d1be64261b89dbef500a2781a";

type SessionData = {
  userAppToken?: string;
  token?: string;
  name?: string;
  email?: string;
};

export const setUserInSession = ({
  userAppToken,
  token,
  name,
  email,
}: SessionData) => {
  if (userAppToken) localStorage.setItem("userAppToken", userAppToken);
  if (token) localStorage.setItem("ctToken", token);
  if (name) localStorage.setItem("name", name);
  if (email) localStorage.setItem("email", email);
};

export const clearUserSession = () => {
  localStorage.removeItem("ctToken");
  localStorage.removeItem("userAppToken");
  localStorage.removeItem("name");
  localStorage.removeItem("email");
};

export const getSessionUser = () => {
  const token = localStorage.getItem("ctToken");
  const name = localStorage.getItem("name");
  const email = localStorage.getItem("email");

  return {
    token,
    name,
    email,
  };
};

export const isSomething = (data: any) => {
  if (data === null || data === undefined) return false;
  if (typeof data === "number") return true;
  if (typeof data === "string" && data.length === 0) return false;
  if (typeof data === "object" && Object.keys(data).length === 0) return false;
  if (Array.isArray(data) && data.length === 0) return false;
  return true;
};

export const formatTimeSlot = (start: string, end: string) => {
  const startDate = dayjs(start);
  const endDate = dayjs(end);

  const monthDay = startDate.format("MMM D");
  const startTime = startDate.format("h:mm A");
  const endTime = endDate.format("h:mm A");

  return `${monthDay} ${startTime} - ${endTime}`;
};

export const isValidSelectedPatients = (selectedPatients: SelectedPets) => {
  if (selectedPatients.length === 0) {
    return false;
  }
  const selectedPatientsWithCompleteData = selectedPatients.filter(
    (pet) => pet.appointment_type && pet.reason
  );
  return selectedPatients.length === selectedPatientsWithCompleteData.length;
};

export const getAge = (birthday: any) => {
  dayjs.extend(relativeTime);
  return dayjs(birthday).fromNow();
};


export const formatData = (d: any) => {
  const startDate = d?.appointment_group[0].start;
  const endDate = d?.appointment_group[0].end;
  const day = dayjs(startDate).date();
  const month = dayjs(startDate).format("MMM");
  const startTime = dayjs(startDate).format("hh:mm A");
  const endTime = dayjs(endDate).format("hh:mm A");
  return {
    name: d?.client.first_name + " " + d?.client.last_name,
    time: `${startTime} - ${endTime}`,
    date: `${month} ${day}`,
    address: d?.client.address,
    noOfPets: d?.appointment_group.length,
    start: d?.appointment_group[0].start,
    end: d?.appointment_group[0].end,
  };
};

export const formatDataUsingChicagoTime = (d: any) => {
  const startDate = d?.appointment_group[0].start;
  const endDate = d?.appointment_group[0].end;

  const formatTo12Hour = (dateString: string) => {
    const match = dateString.match(/T(\d{2}):(\d{2}):\d{2}/);
    if (!match) return "Invalid Time";

    let hours = parseInt(match[1], 10);
    const minutes = match[2];
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${ampm}`;
  };
  const startTime = formatTo12Hour(startDate);
  const endTime = formatTo12Hour(endDate);

  const dateObj = new Date(startDate);
  const day = dateObj.getDate();
  const month = dateObj.toLocaleString("en-US", { month: "short" });

  return {
    name: `${d?.client.first_name} ${d?.client.last_name}`,
    time: `${startTime} - ${endTime}`,
    date: `${month} ${day}`,
    address: d?.client.address,
    noOfPets: d?.appointment_group.length,
    start: startDate,
    end: endDate,
    notified: d?.client.notified,
    email: d?.client?.email
  };
};


export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const loadAddressOptions = async (inputValue: string) => {
  try {
    if (!inputValue) {
      return { options: [], hasMore: false };
    }
    const response = await fetch(
      `${GEO_API_URL}?text=${encodeURIComponent(inputValue)}&apiKey=${API_KEY}&limit=5&filter=circle:-96.3349273565666,30.6278108518964,80000&bias=circle:-96.3349273565666,30.6278108518964,50000|countrycode:none
      `
    );
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();

    return {
      options: data.features.map((feature: any) => ({
        label: feature.properties.formatted,
        value: feature.properties,
      })),
      hasMore: data.features.length === 5,
      additional: { page: 1 + 1 },
    };
  } catch (error) {
    return { options: [], hasMore: false };
  }
};
